const CLASS_NAME_TO_FUNCTION = {}

function afterCreateReduxHookUtil (instance, state) {
  const { className } = instance
  const fn = CLASS_NAME_TO_FUNCTION[className]
  if (!fn) {
    return state
  }
  return fn(instance, state)
}

export default afterCreateReduxHookUtil
